module.exports = __webpack_public_path__ + "img/noconnect.377ae2c7.png";